import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Template, TemplateCreate, TemplateUpdate } from '../../../shared/interfaces/click.interfaces';

const basePath = '/click/templates';

@Injectable({
  providedIn: 'root'
})

export class ClickTemplatesService {
  constructor(private http: HttpClient) { }

  // Get all templates from current and parent dealers
  getTemplates(): Observable<Template[]> {
    return this.http.get<Template[]>(`${basePath}`);
  }

  // Creates a new template for the current dealer
  createTemplate(payload: TemplateCreate): Observable<Template> {
    const body = payload
    return this.http.post<Template>(`${basePath}`, body);
  }

  // Updates a template for the current dealer
  updateTemplate(payload: TemplateUpdate): Observable<Template> {
    const body = payload
    return this.http.put<Template>(`${basePath}`, body);
  }

  // Get details of a specific template
  getTemplateById(id: number): Observable<Template> {
    return this.http.get<Template>(`${basePath}/${id}`);
  }

  // Deletes a specific template
  deleteTemplate(id: number): Observable<any> {
    return this.http.delete<any>(`${basePath}/${id}`);
  }

  // Adds a command to a template
  addCommandToTemplate(templateId: number, commandId: number): Observable<Template> {
    return this.http.post<Template>(`${basePath}/${templateId}/commands/${commandId}`, {});
  }

  // Removes a command from a template
  removeCommandFromTemplate(templateId: number, commandId: number): Observable<Template> {
    return this.http.delete<Template>(`${basePath}/${templateId}/commands/${commandId}`);
  }

  // Adds a notification to a template
  addNotificationToTemplate(templateId: number, eventDefinitionId: number): Observable<Template> {
    return this.http.post<Template>(`${basePath}/${templateId}/notifications/${eventDefinitionId}`, {});
  }

  // Removes a notification from a template
  removeNotificationFromTemplate(templateId: number, eventDefinitionId: number): Observable<Template> {
    return this.http.delete<Template>(`${basePath}/${templateId}/notifications/${eventDefinitionId}`);
  }

}
